(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-settings.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-settings.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState;
const ExpandableArea = svs.components.tipsen.expandableArea.ExpandableArea;
const _svs$ui = svs.ui,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const ResultSettingsSelectorContainer = svs.components.tipsen.routeResult.ResultSettingsSelectorContainer;
const SettingsButton = svs.components.tipsen.couponChoiceButton.SettingsButton;
const ResultSettings = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowingSettings = _useState2[0],
    setIsShowingSettings = _useState2[1];
  const onActivateSettings = useCallback(() => {
    setIsShowingSettings(!isShowingSettings);
  }, [isShowingSettings]);
  const settingsBtnContainer = document.querySelector('.pg_result__settings_button_container');
  let arrowPosition;
  if (settingsBtnContainer) {
    const settingsBtnContainerWidth = settingsBtnContainer.getBoundingClientRect().width;
    if (isShowingSettings) {
      const settingsButton = document.querySelector('.coupon-toolbox-settings-button');
      if (settingsButton) {
        const settingsRect = settingsButton.getBoundingClientRect();
        arrowPosition = settingsBtnContainerWidth - settingsRect.width / 2;
      }
    }
  }
  const idSettings = 'expandable-area-result-settings';
  return React.createElement("div", {
    className: "pg_result__coupon_choises"
  }, React.createElement("div", {
    className: "pg_result__settings_button_container"
  }, React.createElement(SettingsButton, {
    ariaControls: idSettings,
    isShowingSettings: isShowingSettings,
    onClick: onActivateSettings
  })), React.createElement(ExpandableArea, {
    arrowPosition: arrowPosition,
    className: ['pg_coupon_settings_selector', 'pg_coupon_settings_selector--result'],
    "data-testid": "expandable-area",
    id: idSettings,
    isOpen: isShowingSettings
  }, isShowingSettings && React.createElement("div", {
    className: "pg_coupon_settings_selector__container pg_coupon_settings_selector__container--result"
  }, React.createElement(ReactIconButton, {
    className: "pg_coupon_settings_selector__close_btn",
    onClick: onActivateSettings
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  })), React.createElement(ResultSettingsSelectorContainer, null))));
};
setGlobal('svs.components.tipsen.routeResult.ResultSettings', ResultSettings);

 })(window);